/* import __COLOCATED_TEMPLATE__ from './mcp-action-updated-details.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type AppAdminEvent from 'embercom/models/app-admin-event';

interface McpActionUpdatedDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class McpActionUpdatedDetails extends Component<McpActionUpdatedDetailsSignature> {
  @tracked showModal = false;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::McpActionUpdatedDetails': typeof McpActionUpdatedDetails;
    'table-cells/admin-events/mcp-action-updated-details': typeof McpActionUpdatedDetails;
  }
}
